import { ca } from '@cian/analytics';

import { EMortgageOffersTabs } from '../../../../enums/EMortgageOffersTabs';

const ANALYTICS_TABS_MAP: Record<EMortgageOffersTabs | 'seoUrl', string> = {
  [EMortgageOffersTabs.Banks]: 'accredited_banks',
  [EMortgageOffersTabs.Mortgage]: 'mortgage_offers',
  seoUrl: 'seo_url',
};

/**
 * @description Событие: переключение вкладки в блоке ипотечных предложений (банки / офферы / SEO-URL).
 */
export function trackMortgageOffersTabClick(tab: EMortgageOffersTabs | 'seoUrl'): void {
  ca('eventSite', {
    action: 'click',
    category: 'Promo',
    label: ANALYTICS_TABS_MAP[tab],
    name: 'oldevent',
    useLastProducts: true,
  });
}
